import React, { useEffect, useState } from "react";
import dataFteService from "../../services/dataFte.service";
import ChangeDeputyDean from "./changeDeputyDean";

const DeputyDean = () => {
  const [deputyDean, setDeputyDean] = useState("");
  useEffect(() => {
    (async () => {
      //ไปเช็คที่ตาราง doc3 ว่ามี sche / course นี้ยัง
      await dataFteService.getData().then((res) => {
        // console.log(res.data[0].dean);
        setDeputyDean(res.data[0].deputyDean);
      });
    })();
  }, []);
  return (
    <div className="card bg-light">
      <div className="card-body">
        <h3 className="card-title">รองคณบดีฝ่ายวิชาการและวิจัย</h3>
        <h4 className="card-text">
          <strong>{deputyDean}</strong>
        </h4>
        <p>รองคณบดีฝ่ายวิชาการและวิจัย คณะครุศาสตร์อุตสาหกรรม</p>
        <ChangeDeputyDean name={deputyDean} />
      </div>
    </div>
  );
};

export default DeputyDean;
